import _ from 'underscore';

import { imgPath } from '~commonInfra/utils/ImgUrl';

export namespace ImagePreloader {

  const DynamicIconImages: string[] = [
    'busy_large.gif',
  ];

  const SVGIconImages: string[] = [
    'actions_hover.svg',
    'checkbox_empty_hover.svg',
    'checkbox_mixed_hover.svg',
    'checkbox_selected_hover.svg',
    'checkbox_selected_normal.svg',
    'close_x_hover.svg',
    'column_dropdown_arrow_hover.svg',
    'download_small_hover.svg',
    'data_source_content_type_hover_small.svg',
    'edit_small_hover.svg',
    'header_ellipsis_hover.svg',
    'info_hover.svg',
    'magnifying_glass_large_hover.svg',
    'magnifying_glass_large_normal.svg',
    'magnifying_glass_large_white_hover.svg',
    'magnifying_glass_large_white_normal.svg',
    'magnifying_glass_small_hover.svg',
    'panel_hide_hover.svg',
    'panel_show_hover.svg',
    'project_content_type_hover_small.svg',
    'radio_button_empty_disabled.svg',
    'radio_button_empty_hover.svg',
    'radio_button_empty_normal.svg',
    'radio_button_selected_disabled.svg',
    'radio_button_selected_hover.svg',
    'radio_button_selected_normal.svg',
    'run_now_small_hover.svg',
    'show_nav.svg',
    'show_nav_hover.svg',
    'Spaces_Caption_Favorite_Off.svg',
    'Spaces_Caption_Favorite_Off_Active.svg',
    'Spaces_Caption_Favorite_On.svg',
    'Spaces_Caption_Favorite_On_Active.svg',
    'Spaces_Caption_Favorite_Off_White.svg',
    'Spaces_Caption_Favorite_Off_Active_White.svg',
    'Spaces_Caption_Favorite_On_White.svg',
    'Spaces_Caption_Favorite_On_Active_White.svg',
    'Spaces_Data_Status.svg',
    'spaces_toolbar_back.svg',
    'spaces_toolbar_back_active.svg',
    'spaces_toolbar_help.svg',
    'spaces_toolbar_help_active.svg',
    'spaces_toolbar_help_medium.svg',
    'spaces_toolbar_help_medium_active.svg',
    'spaces_toolbar_search.svg',
    'spaces_toolbar_search_active.svg',
    'star_empty_small_hover.svg',
    'star_empty_small_normal.svg',
    'star_selected_small_hover.svg',
    'star_selected_small_normal.svg',
    'thumbnail_ellipsis_hover.svg',
    'thumbnail_ellipsis_normal.svg',
    'tnail_checkbox_selected_hover.svg',
    'tnail_checkbox_selected_normal.svg',
    'view_content_type_hover_small.svg',
    'workbook_content_type_hover_small.svg',
    'notification_empty_bell.svg'
  ];

  export function preloadDynamicIconImages(): void {
    _.each(DynamicIconImages, (image: string) => {
      // TODO: Should imgPath incorporate the static asset prefix?
      new Image().src = imgPath(image);
    });
    _.each(SVGIconImages, (image: string) => {
      // TODO: Should imgPath incorporate the static asset prefix?
      new Image().src = imgPath(image);
    });
  }

}
